<h2 class="sr-only">{{ "ErweiterteSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="erweitert" #form="ngForm">
  <cap-grundstueck-nummer
    (ngModelChange)="erweitert && (erweitert.grundstueckNummer = $event)"
    [hasfocus]="true"
    [ngModel]="erweitert && erweitert.grundstueckNummer"
    [searchMode]="gbGemeindeSearchMode"
    heading="GrundstueckNummer"
    name="grundstueckNummer"></cap-grundstueck-nummer>
  <cap-form-row column-classes="col-md-1,col-md-2">
    <cap-form-control invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
      <input
        (ngModelChange)="erweitert && erweitert.egrid && (erweitert.egrid.value = $event)"
        [ngModel]="erweitert && erweitert.egrid && erweitert.egrid.value"
        name="egrid.value"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <cap-widg-beleg
    (ngModelChange)="erweitert && (erweitert.beleg = $event)"
    [ngModel]="erweitert && erweitert.beleg"
    [searchMode]="gbAmtSearchMode"
    heading="Beleg"
    name="beleg"></cap-widg-beleg>
  <cap-stichwort-ablaufdatum
    [(ngModel)]="erweitert"
    heading="StichwortOderAblaufdatum"
    name="stichwort-ablaufdatum"></cap-stichwort-ablaufdatum>
  <div class="row mt-4 mb-5">
    <div class="col-3">
      <cap-rechte-selection
        (ngModelChange)="erweitert && (erweitert.rechteSelection = $event)"
        [mitArtGrundpfandrecht]="false"
        [ngModel]="erweitert && erweitert.rechteSelection"
        name="rechteSelection"></cap-rechte-selection>
    </div>
    <div class="col-3">
      <cap-history-options
        (ngModelChange)="erweitert && (erweitert.historySearchOptions = $event)"
        [ngModel]="erweitert && erweitert.historySearchOptions"
        name="historySearchOptions"></cap-history-options>
    </div>
  </div>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
